import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=1220e9b7&scoped=true"
import script from "./FormContent.vue?vue&type=script&lang=js"
export * from "./FormContent.vue?vue&type=script&lang=js"
import style0 from "./FormContent.vue?vue&type=style&index=0&id=1220e9b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220e9b7",
  null
  
)

export default component.exports